import * as React from 'react';

function BitreelLockUp(props) {
    return (
        <svg
            width={64}
            height={17}
            viewBox="0 0 64 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15.643 2.306h2.621c1.232 0 2.122.184 2.672.552.55.368.826.95.826 1.746 0 .55-.155 1.005-.464 1.364-.304.356-.75.586-1.339.692v.064c1.41.24 2.114.981 2.114 2.221 0 .83-.282 1.477-.845 1.943-.558.465-1.341.698-2.348.698h-3.237v-9.28zm1.079 3.973h1.777c.762 0 1.31-.118 1.644-.355.334-.241.502-.645.502-1.213 0-.52-.187-.895-.56-1.123-.372-.233-.964-.35-1.776-.35h-1.587V6.28zm0 .914v3.473h1.936c.749 0 1.312-.144 1.688-.432.381-.292.572-.747.572-1.365 0-.575-.195-.998-.584-1.27-.386-.27-.974-.406-1.765-.406h-1.847zM24.072 11.586v-9.28h1.08v9.28h-1.08zM30.56 11.586h-1.08V3.264h-2.939v-.958h6.957v.958H30.56v8.322zM36.761 6.425h.635c.622 0 1.081-.103 1.377-.31.297-.208.445-.534.445-.978 0-.44-.153-.753-.457-.94-.3-.186-.768-.279-1.403-.279h-.597v2.507zm0 1.6v3.561h-1.968v-9.28h2.705c1.26 0 2.194.23 2.799.692.605.457.908 1.153.908 2.088 0 .546-.15 1.033-.451 1.46-.3.423-.726.755-1.276.997a374.95 374.95 0 002.73 4.043h-2.184l-2.215-3.561H36.76zM48.72 11.586h-5.344v-9.28h5.344v1.612h-3.377v2.038h3.142v1.612h-3.142V9.96h3.377v1.625zM56.007 11.586h-5.344v-9.28h5.344v1.612H52.63v2.038h3.142v1.612H52.63V9.96h3.377v1.625zM57.95 11.586v-9.28h1.967V9.96h3.765v1.625H57.95z"
                fill="#000"
            />
            <path
                d="M.865 8.934l3.92-2.09v4.347L.865 8.934zM12.124 4.967l-3.92-2.294v4.393l3.92-2.1z"
                fill="#14738E"
            />
            <path d="M.865 3.977L6.88.777v4.939H.865V3.977z" fill="#1CA8BA" />
            <path
                d="M6.879 5.734l-6.014 3.2V3.996H6.88v1.738zM6.11 8.157l6.014-3.2v4.939H6.111V8.157z"
                fill="#1CA8BA"
            />
            <path
                d="M12.123 9.915l-6.013 3.2v-4.94h6.013v1.74z"
                fill="#1CA8BA"
            />
        </svg>
    );
}

export default BitreelLockUp;
